<template>
  <div>
    <app-overlay-loader v-if="preloader" />
    <div class="card card-with-shadow border-0 h-100 employee-preview-card">
      <div class="card-body position-relative d-flex flex-column">
        <VueHtml2pdf
          :show-layout="false"
          :float-layout="false"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="myPDF"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-content-width="100%"
          ref="html2Pdf">
            <section slot="pdf-content">
              <div v-if="Object.keys(site).length == 0">
          <app-empty-data-block :message="$t('nothing_to_show_message')" />
              </div>
              <div v-else>
                <div class="d-flex flex-column">
                      
                  <div style="text-align: end" v-if="hideOnPrint == true">
                    <el-tooltip
                      placement="top"
                      :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                      :content="$t('attach_document_detail')">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          data-toggle="modal"
                          @click="openAttachDocumentModal">
                          {{ $t("attach_generated_documnent") }}
                        </button>
                    </el-tooltip>
                    <el-tooltip
                      placement="top"
                      :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                      :content="$t('assign_user_detail')">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          data-toggle="modal"
                          @click="openAssignUserModal">
                          {{ $t("assign_user") }}
                        </button>
                    </el-tooltip>
                    <el-tooltip
                      placement="top"
                      :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                      :content="$t('print_detail')">
                      <button
                        type="button" 
                        @click.prevent="generateReport" 
                        class="btn btn-primary btn-sm">Print</button>
                    </el-tooltip>
                  </div>
                  <h5
                    class="mb-3 mt-3"
                    style="font-size: 1.15rem; color: var(--job-title-color)"
                  >
                    {{ site[0].title }}
                  </h5>

                  <p class="mb-3 font-size-90">{{ site[0].description }}</p>
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <p class="mb-3">
                        <b>{{ $t("assignment_structure") }}</b><br>
                        {{ site[0].assignment_structure }}
                      </p>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <p class="mb-3">
                        <b>{{ $t("site_address") }}</b><br>
                        {{ site[0].site_address }}
                      </p>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <p class="mb-3">
                        <b>{{ $t("site_info") }}</b><br>
                        {{ site[0].site_info }}
                      </p>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <p class="mb-3">
                        <b>{{ $t("start_date") }}</b><br>
                        {{ site[0].starting_hours }}
                      </p>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <p class="mb-2">
                        <b>{{ $t("end_date") }}</b> <br> 
                        {{ site[0].ending_hours }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="d-flex flex-column">
                  <div style="text-align: end" v-if="hideOnPrint == true">
                    <el-tooltip
                      placement="top"
                      :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                      :content="$t('add_task_detail')">

                      <button
                        type="button"
                        class="btn btn-primary btn-sm mb-2"
                        data-toggle="modal"
                        @click="openTaskAddModal()">
                        {{ $t("add_task") }}
                      </button> 
                    </el-tooltip>
                    
                    <el-tooltip
                      placement="top"
                      :effect="theemMode.darkMode == true ? 'light' : 'dark'"
                      :content="$t('site_induction_tasks_detail')">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm mb-2"
                        data-toggle="modal"
                        @click="openSiteViewModal()">
                        {{ $t("site_induction_tasks") }}
                      </button>
                    </el-tooltip>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div
                      style="text-align: end; justify-content: space-between"
                      class="d-flex"
                    >
                      <label>{{ $t("user_list") }}</label>
                      
                    </div>
                    <app-table :id="tableId" :options="options" @action="getListAction" />
                    <!-- <table class="table">
                      <tr>
                        <th>S.No</th>
                        <th>Title</th>
                        <th>Start Date</th>
                        <th>Due Date</th>
                        <th>User</th>
                        <th>Action</th>
                      </tr>
                      <tr v-for="(task, index) in tasks" :key="index">
                        <td>{{ index + 1 }}</td>
                        <td>{{ task.title }}</td>
                        <td>{{ task.start_date }}</td>
                        <td>{{ task.due_date }}</td>
                        <td>{{ task.users[0].full_name }}</td>
                        <td>
                          <button
                            type="button"
                            class="btn p-0"
                            data-toggle="modal"
                            @click="openTaskEditModal(task.id)"
                          >
                            <app-icon name="edit" />
                          </button>
                          <button
                            type="button"
                            class="btn p-0"
                            data-toggle="modal"
                            @click="openTaskViewModal(task.id)"
                          >
                            <app-icon name="eye" />
                          </button>
                        </td>
                      </tr>
                    </table> -->
                  </div>
                </div>
              </div>
            </section>
        </VueHtml2pdf>
      </div>
    </div>
    <myjob-site-attach-documentmodal
      :id="site[0].id"
      v-if="isAttachDocumentModalActive"
      @close-modal="closeModal"
    />
    <job-site-assign-usermodal
      :id="site[0].id"
      v-if="isAssignUserModalActive"
      @close-modal="closeAssignUserModal"
    />

    <task-mytaskmodal
      v-if="isMYTASKModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeTaskModal"
      :id="taskId"
    />
    <site-taskaddmodal
      :tableId="tableId"
      :getSite="getSite"
      :siteid="site[0].id"
      :selected-url="selectedUrl"
      v-if="isTaskAddModalActive"
      @close-modal="closeTaskAddModal"
    />
    <site-taskeditmodal
      :tableId="tableId"
      :getSite="getSite"
      :id="taskId"
      :title="title"
      v-if="isTaskEditModalActive"
      @close-modal="closeTaskEditModal"
    />
    <mysite-viewmodal
      v-if="isSiteViewModalActive"
      :id="site[0].id"
      :url='taskUrl'
      @close-modal="closeSiteViewModal"/>
    <task-reminder
      v-if="isTaskReminderModalActive"
      modal-id="reminder-Modal"
      :taskId="task_id"
      @afterSubmitDone="reloadAllState"
      @close-modal="isTaskReminderModalActive = false"
    />
  </div>
</template>

<script>
import { TableHelpers } from "../../../../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../../../core/helpers/CoreLibrary.js";

import {
  COMPANY_JOB_SITE_SHOW,
  COMPANY_JOB_SITE_SHOW_LIST,
  COMPANY_JOB_USERS_WITH_TASK,
  COMPANY_JOB_UPDATE,
  GET_SITE_USER_ASSIGNED_LIST, 
  MY_TASK_SHOW,
  CATEGORIES,
} from "../../../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../../../Helpers/AxiosHelper.js";

export default {
  extends: CoreLibrary,
  mixins: [TableHelpers],
  name: "List",
  site: 0,
  props: {
    id: Number,
  },
  data() {
    return {
      taskUrl: '',
      hideOnPrint: true,
      taskId:'',
      isSiteViewModalActive: false,
      isTaskAddModalActive: false,
      isMYTASKModalActive:false,
      isAttachDocumentModalActive: false,
      isTaskEditModalActive: false,
      isAssignUserModalActive: false,
      isTaskReminderModalActive: false,
      siteId: this.id,
      site: {},
      preloader: true,
      selectedUrl: '',
      tasks: [],
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: COMPANY_JOB_USERS_WITH_TASK,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("users"),
            type: "custom-html",
            key: "users",
            modifier: (value) => {
              return `<span>${this.$t(value.full_name)}</span>`;
            },
          },
          {
            title: this.$t("task_completed"),
            type: "custom-html",
            key: "users",
            modifier: (value) => {
              return `<span><b>${value.completed}<b></span>`;
            },
          },
          {
            title: this.$t("task_incompleted"),
            type: "custom-html",
            key: "users",
            modifier: (value) => {
              return `<span><b>${value.incompleted}<b></span>`;
            },
          },
        ],
        // actions: [
        //   {
        //     title: this.$t("edit"),
        //     icon: "edit",
        //     type: "none",
        //     component: "app-add-modal",
        //     modalId: "demo-add-edit-Modal",
        //   },
        //   {
        //     title: this.$t("view"),
        //     icon: "eye",
        //     type: "none",
        //     component: "app-add-modal",
        //     modalId: "demo-add-edit-Modal",
        //   },
        //   {
        //     title: this.$t("reminder"),
        //     icon: "eye",
        //     type: "none",
        //     component: "task-reminder",
        //     modalId: "demo-add-edit-Modal",
        //   },
        // ],
        filters: [
          {
            title: this.$t("search_and_select"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: false,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 3,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    // this.options.columns = [...this.options.columns, this.actionObj];
    this.options.columns = [...this.options.columns];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    generateReport() {
      this.hideOnPrint = false;
      this.$refs.html2Pdf.generatePdf();
    },
    getListAction(rowData, actionObj, active) {
     if (actionObj.title == this.$t("edit")) {
        this.openTaskEditModal(rowData.id);
      } else if (actionObj.title == this.$t("view")) {
        this.openTaskViewModal(rowData.id); 
      }else if (actionObj.title == this.$t('reminder')){
        this.openReminderModal(rowData.id);
      }
    },
    openSiteViewModal() {
      this.taskUrl = COMPANY_JOB_SITE_SHOW_LIST;
      this.isSiteViewModalActive = true;
    },
    closeSiteViewModal() {
      $("#demo-site-view-Modal").modal("hide");
      this.isSiteViewModalActive = false;
    },

    openAssignUserModal() {
      this.isAssignUserModalActive = true;
    },
    closeAssignUserModal() {
      $("#demo-assign-user-Modal").modal("hide");
      this.isAssignUserModalActive = false;
    },
    openTaskEditModal(id) {
      // this.taskid = id;
      // this.selectedUrl = `${COMPANY_JOB_SITE_TASK_SHOW}/${id}`;
      this.taskId = id;
      this.title = 'Site Task';
      this.isTaskEditModalActive = true;
    },
    openTaskAddModal() {
      $("#demo-task-add-Modal").modal("show");
      this.isTaskAddModalActive = true;
    },
    openAttachDocumentModal() {
      this.isAttachDocumentModalActive = true;
    },
    closeModal() {
      $("#demo-attach-document-Modal").modal("hide");
      this.isAttachDocumentModalActive = false;
    },
    openTaskViewModal(taskid) {
      this.taskId = taskid;
      this.isMYTASKModalActive = true;
    },
    closeTaskAddModal() {
      $("#demo-task-add-Modal").modal("hide");
      this.$hub.$emit("reload-" + this.tableId);
      this.isTaskAddModalActive = false;
      // this.reSetData();
    },
    closeTaskEditModal() {
      // $("#my_task_modal").modal("hide");
      this.$hub.$emit("reload-" + this.tableId);
      this.isTaskEditModalActive = false;
      this.selectedUrl = "";
    },
    closeTaskModal() {
      $("#demo-assign-user-Modal").modal("hide");
      this.$hub.$emit("reload-" + this.tableId);
      this.isMYTASKModalActive = false;
    },
    getSite() {
      axiosGet(COMPANY_JOB_SITE_SHOW + "/" + this.id)
        .then((res) => {
          this.preloader = true;
          this.site = res.data;
          this.innerId = this.id;
        })
        .catch((error) => {
          
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    getSiteUsersWitthTasks() {
      this.options.url = COMPANY_JOB_USERS_WITH_TASK +'/'+ this.id;
      this.$hub.$emit("reload-" + this.tableId);
    },
    searchAndSelectFilterOptions() {
      axiosGet(GET_SITE_USER_ASSIGNED_LIST + "/" + this.id).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },    
    openReminderModal(task_id){
      this.isTaskReminderModalActive = true;
      this.task_id = task_id;
    },
  },
  mounted() {
    this.getSite();
    console.log(this.id);
    // this.getSiteUsersWitthTasks();
  },
   computed: {
    theemMode() {
      return this.$store.state.theme;
    },
  },
  watch: {
    id: function (newVal, oldVal) {
      this.getSite();
      this.getSiteUsersWitthTasks();
      this.searchAndSelectFilterOptions();
    },
  },
};
</script>
